import { useTheme } from '@mui/material/styles';
import { IconButton, Toolbar, useMediaQuery } from '@mui/material';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { notify } from '../../../../utils/methods/notification';
import { formatPathName } from '../../../../../utils/utils'
import HeaderAppBar from './HeaderAppBar';
import MobileSection from '../../../../../layout/MainLayout/Header/HeaderContent/MobileSection';
import SwitchButton from '../../../common/SwitchButton';
import { useNavigate, useLocation } from 'react-router';
import Profile from './Profile';
import { useSelector } from 'react-redux';

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme?.breakpoints.down('md'));
  const portal_access = useSelector((state) => state?.loginData)?.portal_access;
  const [portalSelected, setPortalSelected] = useState('bmr');
  const navigate = useNavigate()
  const location = useLocation();
  const { pathname } = location;
  const portalOptions = [
    { value: 'cdm', label: 'CDM' },
    { value: 'bmr', label: 'VtoV' },
  ];

  const logoutNotify = () => {
    notify.success('Logout successfully');
  }

  const handleToggleChange = (value) => {
    if (value) {
      setPortalSelected
      navigate("/products")
    }
  }

  return (
    <HeaderAppBar open={open} {...{
      position: 'fixed',
      color: 'inherit',
      elevation: 0,
      sx: { borderBottom: `1px solid ${theme?.palette?.divider}` }
    }}>
      <Toolbar sx={{ paddingLeft: "15px !important", paddingRight: "17px !important" }}>
        {matchDownMD && <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          sx={{ color: "text.primary", bgcolor: "grey.200", ml: { xs: 0, lg: -2, } }}
        >
          {!open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </IconButton>}
        <span className="font-bold ml-1 xs:ml-3 text-sm md:text-base w-[110px] 1sm:!w-full break-all truncate overflow-hidden whitespace-nowrap">
                  {formatPathName(pathname)}
        </span>

        <div className="flex md:justify-end md:w-screen mr-2 ">
          {portal_access == 3 && <SwitchButton
            options={portalOptions}
            value={portalSelected}
            onChange={handleToggleChange}
          />}
        </div>
        {portal_access == 3 && <p className="sm:p-2 md:pl-6 md:pr-4 text-lg text-gray-400">|</p>}
        {matchDownMD ?
          <MobileSection handleSetOpenLogoutSnackbarTrue={logoutNotify} />
          :
          <Profile />
        }
      </Toolbar>
    </HeaderAppBar>
  );
};

export default Header;
